// Collecting the Android app bonus inside the app: a Play Integrity check through the app
// (lib/notify.ts verifyApp), then the outcome in words. A pass pays on the server and fires
// APP_BONUS_EVENT, so the "+50 coins" sticker in Layout shows it. The words are shared with the
// support assistant (@gaintplay/core/app-bonus), which marks them for translation.
import { appBonusOutcome } from '@gaintplay/core/app-bonus';
import { APP_BONUS_EVENT } from './appDevice';
import { verifyApp } from './notify';
import { t } from '../i18n';

export interface CollectResult {
  ok: boolean;
  text: string;
}

export async function collectAppBonus(coins: number): Promise<CollectResult> {
  const r = await verifyApp();
  if (r.state === 'passed' && r.bonus === 'granted')
    window.dispatchEvent(new CustomEvent(APP_BONUS_EVENT, { detail: coins }));
  // A check that never answered reads like one that couldn't run.
  const o = appBonusOutcome(r.state === 'unknown' ? 'unavailable' : r.state, r.bonus, coins);
  // o.message is one of the msg('…') in @gaintplay/core/app-bonus.
  return { ok: o.ok, text: t(o.message, o.values) };
}
